import React from 'react';
import { FORECAST_COLORS, appendOrderStatusParams } from '../../constants';
import PeriodTable from './PeriodTable';

const FORECAST_FILTER_MAP = {
  'next_30': 'due_date_min=today&due_date_max=30',
  '31_60': 'due_date_min=31&due_date_max=60',
  '61_90': 'due_date_min=61&due_date_max=90',
  '90_plus': 'due_date_min=91',
};

const ProvisionForecastSection = ({ data, selectedStatuses }) => {
  const buildFilterParams = (period) => {
    const baseParams = `status__in=TO_BE_ISSUED,AWAITING_PAYMENT&${FORECAST_FILTER_MAP[period.period]}`;
    return appendOrderStatusParams(baseParams, selectedStatuses);
  };

  return (
    <PeriodTable
      title="Provision Forecast"
      emptyMessage="No forecast data available"
      data={data}
      colorMap={FORECAST_COLORS}
      buildFilterParams={buildFilterParams}
    />
  );
};

export default ProvisionForecastSection;
